import React from 'react';
import { useSearchBarContext } from 'components/Filters/context/SearchBarContext/SearchBarContext';
import * as Styled from './styled';

const _TextInput = React.forwardRef(
    (
        {
            inputValue,
            inputValueLength,
            placeholder,
            predictiveInput,
            isDisabled = false,
            handleChange,
            handleFocus,
            handleKeyPress,
            handleKeyDown,
        }: {
            inputValue: string;
            inputValueLength: number;
            placeholder: string;
            predictiveInput: string;
            isDisabled?: boolean;
            handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
            handleFocus: () => void;
            handleKeyPress: (
                event: React.KeyboardEvent<HTMLInputElement>,
            ) => void;
            handleKeyDown: (
                event: React.KeyboardEvent<HTMLInputElement>,
            ) => void;
        },
        forwardedRef:
            | ((instance: HTMLInputElement | null) => void)
            | React.MutableRefObject<HTMLInputElement | null>
            | null,
    ) => (
        <Styled.GroupItemGrow inputValueLength={inputValueLength}>
            <Styled.InputNoFocusStyle
                ref={forwardedRef}
                value={inputValue}
                name="search"
                placeholder={placeholder}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                onKeyPress={handleKeyPress}
                onFocus={handleFocus}
                id="search-input"
                type="search"
                inputMode="search"
                size="md"
                variant="ghost"
                isDisabled={isDisabled}
            />

            <Styled.Autocomplete gutter={0}>
                <Styled.UserInput>
                    <Styled.Inline contrast="low">{inputValue}</Styled.Inline>
                </Styled.UserInput>
                <Styled.Prediction>
                    <Styled.Inline contrast="low">
                        {predictiveInput.substring(inputValue.length)}
                    </Styled.Inline>
                </Styled.Prediction>
            </Styled.Autocomplete>
        </Styled.GroupItemGrow>
    ),
);

const TextInput = React.forwardRef(
    (
        _,
        forwardedRef:
            | ((instance: HTMLInputElement | null) => void)
            | React.MutableRefObject<HTMLInputElement | null>
            | null,
    ) => {
        const {
            inputRef,
            inputValue,
            placeholder,
            predictiveInput,
            handleFocus,
            handleKeyPress,
            handleKeyDown,
            onInputChange,
            isSearchBarDisabled,
        } = useSearchBarContext();

        return (
            <_TextInput
                ref={forwardedRef ?? inputRef}
                inputValue={inputValue}
                inputValueLength={inputValue.length}
                placeholder={predictiveInput ? '' : placeholder}
                handleChange={(
                    event: React.ChangeEvent<HTMLInputElement>,
                ): void => {
                    onInputChange(event.target.value);
                }}
                handleKeyPress={handleKeyPress}
                handleKeyDown={handleKeyDown}
                handleFocus={handleFocus}
                predictiveInput={predictiveInput}
                isDisabled={isSearchBarDisabled}
            />
        );
    },
);

export default TextInput;
